interface ConfigBannerProps {
  configured: boolean;
}

/** Warns the operator when the server has no ps-integrations credentials. */
export function ConfigBanner({ configured }: ConfigBannerProps) {
  if (configured) return null;
  return (
    <div className="banner warn">
      ⚠️ Server is missing <code>PS_INTEGRATIONS_HOST</code> /{" "}
      <code>PS_INTEGRATIONS_API_KEY</code>. Copy <code>.env.example</code> to{" "}
      <code>.env</code> and restart — API calls will return 503 until then.
    </div>
  );
}
